import styled, { css } from 'styled-components';

import PeopleSVG from '@web/assets/svg/UI/people-alt.svg';
import {
  MESSAGE_SIDEBAR_RIGHT_MARGIN,
  MESSAGE_PADDING,
  MESSAGE_SIDEBAR_WIDTH,
} from '@web/conversations/consts/layout';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export const IconWrapper = styled.div`
  margin: 0 ${MESSAGE_SIDEBAR_RIGHT_MARGIN}px 0 ${MESSAGE_PADDING}px;
  width: ${MESSAGE_SIDEBAR_WIDTH}px;
  flex-shrink: 0;

  & > svg {
    display: block;
  }
`;

export const Name = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const HeaderActionsWrapper = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const BadgesWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  svg {
    outline: none;
  }
`;

export const ArchivedBadgeWrapper = styled.div`
  margin-left: 40px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 5px;
  overflow: hidden;
  margin-right: 40px;
`;

export const PeopleIcon = styled(PeopleSVG)<{ isActive?: boolean }>`
  color: inherit;
  transition: inherit;
`;

type MembersButtonProps = {
  isActive: boolean;
};
export const MembersButton = styled.button<MembersButtonProps>`
  ${({ isActive = true, theme: { colors } }) => css`
    --color: ${isActive ? colors.primary : colors.iconGray};
  `}

  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: var(--color);
  display: flex;
  flex-flow: row nowrap;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  padding: 0 7px;
  transition:
    color 0.125s ease,
    background 0.3s ease,
    opacity 0.3s ease;
  ${PeopleIcon} {
    opacity: ${({ isActive }) => (isActive ? 1 : 0.65)};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.hoverBrand};

    ${PeopleIcon} {
      opacity: 1;
    }
  }
`;
